/**
 * What the sidebar's search box does with the text it holds when the form is
 * submitted. Pure so the "clears itself after submitting" contract (suite I-1,
 * live finding #17) is pinned by a spec rather than by driving the browser.
 */
export interface AGUSidebarSearchSubmission {
    /** The trimmed query to emit, or null when there is nothing to search for. */
    readonly Query: string | null;
    /** What the box should hold afterwards: empty once a query left, unchanged otherwise. */
    readonly NextText: string;
}

/**
 * Submitting a non-empty box hands the trimmed query on and empties the box —
 * the query has moved to the Search module's own hero, so leaving a copy behind
 * in the sidebar reads as an unapplied filter. A blank or whitespace-only box
 * submits nothing and keeps whatever the member typed.
 */
export function SubmitSidebarSearch(text: string): AGUSidebarSearchSubmission {
    const query = text.trim();
    if (query.length === 0) return { Query: null, NextText: text };
    return { Query: query, NextText: '' };
}
